import { render, staticRenderFns } from "./CyclesTable.vue?vue&type=template&id=56b61a98"
import script from "./CyclesTable.vue?vue&type=script&lang=js"
export * from "./CyclesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports